import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Rapid7 extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M15.8153948,3 L1.4715675,3 C1.68913796,3.22152629 1.90670842,3.45096423 2.10449975,3.69226966 C3.71056535,5.63853634 4.55711225,8.08323718 4.55711225,10.7731993 C4.55711225,14.9268172 2.80863689,18.672985 0,21.196983 L8.78193506,21.196983 L12.9553321,10.824625 L7.73364101,10.824625 L8.60392286,6.80154937 L18.9761002,6.80154937 L13.528927,21.196983 L15.6650733,21.196983 C20.6375474,21.228449 24,17.098566 24,12.0825779 C24,7.06658975 20.7957805,3 15.8114389,3" />
      </svg>
    );
  }
}

export default Rapid7;
